<template>
  <div class="descargas">
    <Titulo titulo="Descargas" />
    <div>
      <b-row>
        <b-col cols="12" md="8">
          <!-- margin-right: 30%; -->
          <div class="margin-lateral">
            <div>
              <h4 class="color-secundary">
                En este espacio encuentre los manuales y los formatos necesarios
                para realizar las operaciones generales del portal
                transaccional.
              </h4>
              <br />
              <template v-for="(categoria, index) in documentos">
                <span class="color-primary" :key="'sec_' + index">{{
                  categoria.tipo
                }}</span>
                <div class="m-3" :key="'doc_' + index">
                  <div
                    v-for="(archivo, index) in categoria.archivos"
                    :key="index"
                    class="listas"
                  >
                    <i class="fa fa-sort-down fa-2x color-secundary"></i>
                    &nbsp;
                    <a
                      @click="descargar(archivo)"
                      target="_blank"
                      style="cursor: pointer"
                      >{{ archivo.archivo }}</a
                    >
                  </div>
                </div>
              </template>
            </div>
            <br />
          </div>
        </b-col>

        <!-- Panel Derecho -->
        <Recomendaciones>
          <b class="color-secundary" style="font-size: 24px">Recomendaciones</b>
          <p style="font-size: 15px; margin-top: 10px">
            <b>Instructivos y formatos de cargue</b>
            <br />Existen varios tipos de novedades que deben reportarse, cada
            uno con condiciones especiales; la novedad puede notificarse de
            manera individual y/o masiva adjuntando un archivo donde se
            relacionen las operaciones afectadas.
            <br />
          </p>

          <hr class="background-secundary mt-4 mb-4" />
          <p style="margin-top: 18px; font-size: 15px">
            Despliegue los contenidos para acceder a más información.
          </p>
          <SelectComponet
            :data="SelectDescargas"
            @selectedValue="formate = $event"
          ></SelectComponet>
          <div>
            <div
              v-html="SelectDescargasDefiniciones[formate - 1]"
              style="font-size: 15px"
            ></div>
          </div>
        </Recomendaciones>
      </b-row>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import SelectDescargas from "@/data/SelectDescargas.json";
import SelectDescargasDefiniciones from "@/data/SelectDescargasDefiniciones.json";
import FileSaver from "file-saver";

export default {
  name: "Descargas",
  data() {
    return {
      documentos: [],
      params: {
        paginar: false,
        tipo: null,
      },
    };
  },
  computed: {},
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    SelectComponet: () => import("@/components/form/Select.vue"),
    Recomendaciones: () => import("@/containers/layout/Recomendaciones.vue"),
  },
  methods: {
    async descargar(archivo) {
      this.$store.commit("SET_LOADING", true);
      try {
        let { data } = await this.$store.getters.api.post(
          "/informes/obtener_documento",
          {
            id: archivo.id,
          },
          { responseType: "arraybuffer" }
        );

        if (data) {
          FileSaver.saveAs(
            new Blob([data]),
            archivo.archivo + "." + archivo.type_file
          );
        }
      } catch (err) {
        this.$toasted.show(
          "Lo sentimos, ocurrió un error al intentar descargar el documento: " +
            archivo.archivo,
          {
            theme: "toasted-primary",
            position: "top-right",
            duration: 10000,
          }
        );
      }
      this.$store.commit("SET_LOADING", false);
    },
    async getDocumentos() {
      try {
        const { data } = await this.$store.state.api.get(
          "/informes/portal_documento",
          { params: this.params }
        );

        let documentos = [];

        data.datos.forEach((element) => {
          if (
            documentos.find((element_) => element_.tipo === element.tipo) ===
            undefined
          ) {
            documentos.push({
              tipo: element.tipo,
              archivos: data.datos.filter(
                (element_) => element_.tipo === element.tipo
              ),
            });
          }
        });

        this.documentos = documentos;
      } catch (err) {
        console.log(err);
      }
    },
    selectValue() {
      console.log("here");
    },
  },
  data() {
    return {
      SelectDescargas: SelectDescargas,
      SelectDescargasDefiniciones: SelectDescargasDefiniciones,
      documentos: [],
      formate: "",
    };
  },
  mounted() {
    this.getDocumentos();
  },
};
</script>